import { render, staticRenderFns } from "./GanttChart.vue?vue&type=template&id=4848b908&scoped=true"
import script from "./GanttChart.vue?vue&type=script&lang=js"
export * from "./GanttChart.vue?vue&type=script&lang=js"
import style0 from "./GanttChart.vue?vue&type=style&index=0&id=4848b908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4848b908",
  null
  
)

export default component.exports